/** Class name apply on all lazy background image visible */
export var LAZY_BACKGROUND_VISIBLE_CLASS_NAME = 'lazy-backgroun-image-visible';
//# sourceMappingURL=lazyBacgroundImage.constant.js.map